import React from "react";

const WhyChooseReactNative = () => {
  return ( 
    <section className="py-20 px-6 bg-white w-full "> 
      <div className="mx-auto">

        <h2 className="text-3xl font-bold mb-6 text-center">
          Why Choose Our React Native<span className="text-[#ff4a17]"> App Development</span>
        </h2>

        <div className="space-y-6 text-gray-600 leading-relaxed text-sm">
          
          <p>
            As a reliable React Native development partner, we build high-quality
            cross-platform mobile applications using a single codebase for both
            iOS and Android. Our developers leverage modern tools like React,
            JavaScript, TypeScript, and the React Native ecosystem to deliver
            fast, responsive, and feature-rich apps. We ensure smooth performance,
            native-like user experience, and visually appealing UI designs that
            work seamlessly across devices.
          </p>

          <p>
            We focus on scalability and efficiency by using reusable components,
            modular architecture, and robust third-party integrations. Our apps
            support real-time features, push notifications, analytics, and API
            connectivity to ensure your product is future-ready. With faster
            development cycles and reduced costs, React Native helps you launch
            your app quickly without compromising quality.
          </p>

          <p>
            Our development process is aligned with your business goals. We help
            you validate ideas, prioritize key features, and build a roadmap for
            growth. Through continuous testing, performance optimization, and UX
            improvements, we ensure your application delivers a consistent and
            engaging user experience across platforms while maintaining high
            security and reliability standards.
          </p>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseReactNative;